class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer')._updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartNote = this.querySelector('.cart__note .field__input');
    if(this.cartNote) {
      this.cartNote.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300));
    }
    
    this.closeButton = null;
    this.openButton = null;
    this.quantityButtons = null;
    
    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this._closeCart());
    document.querySelector('.click-capture').addEventListener('click', (event) => {
        this._closeCart();
    });

    this.cartProgressEnabled = settings.cartProgressEnabled;
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
     .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this._updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  
  async connectedCallback() {
    this._initEventListeners();
  }

  _openCart(e) {
    if(e){
      e.preventDefault();
    }
    this._updateCart()
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
    document.body.classList.add('open-cart');
  }

  _closeCart() {
    this.upsellProduct = this.querySelector('[data-bundle-product]');
    if(this.upsellProduct) this.showUpsell(false);
    document.body.classList.remove('open-cart');
  }

  async _updateCart() {
    const res = await fetch('/?section_id=cart-drawer');
    const section = await res.text();
    const cartDrawer = document.createElement('div');
    cartDrawer.innerHTML = section;
  
    // Define the parent elements
    const parentSelectors = ['cart-items', '.cart__footer', 'cart-progress'];
  
    // Loop through each parent element and update its .js-contents child
    parentSelectors.forEach(parentSelector => {
      const updatedCartContents = cartDrawer.querySelector(`${parentSelector} .js-contents`);
      const currentCartContents = document.querySelector(`${parentSelector} .js-contents`);
      if (currentCartContents && updatedCartContents) {
        currentCartContents.innerHTML = updatedCartContents.innerHTML;
      } else {
        document.querySelector('cart-drawer').innerHTML = section;
      }
    });
    
    this._initEventListeners();
    this.upsellProduct = this.querySelector('[data-bundle-product]');
    if(this.upsellProduct) this.showUpsell(true);
  }

  _updateQuantity(line, quantity, name) {
   this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);        
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        this._updateCart();
        this._updateCartCount();
      })
      .catch((error) => {
        console.error;
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  async _updateCartCount() {
    const res = await fetch('/?section_id=header');
    const section = await res.text();
    const header = document.createElement('div');
    header.innerHTML = section;
  
    const updatedBubble = header.querySelector('.cart-count-bubble');
    const currentBubble = document.querySelector('.cart-count-bubble');
      
    if (currentBubble && updatedBubble) {
      currentBubble.innerHTML = updatedBubble.innerHTML;
    }
  }

  _initEventListeners() {
    this.closeButton = this.querySelector('.side-panel-close');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => this._closeCart(event));
    }
    this.openButton = document.querySelector('a.header__icon--cart');
    if (this.openButton) {
      this.openButton.addEventListener('click', (event) => this._openCart(event));
    }
    this.quantityButtons = this.querySelectorAll('quantity-input .quantity__button');

    this.upsellAddButtons = this.querySelectorAll('.cart-drawer--recommendations--product button');
    if(this.upsellAddButtons) {
      this.upsellAddButtons.forEach(button => button.addEventListener('click', (event) => this.addUpsellToCart(event, button)));
    }
  }

  reinitializeEventListeners() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this._closeCart());
    }
    if (this.openButton) {
      this.closeButton.removeEventListener('click', this._openCart());
    }
    if(this.quantityButtons) {
      this.quantityButtons.forEach(button => {
        this.closeButton.removeEventListener('click', this._updateQuantity());
      })
    }
    if(this.upsellAddButtons) {
      this.upsellAddButtons.forEach(button => {
        button.removeEventListener('click', this.addUpsellToCart(event));
      })
    }
    
    this.initEventListeners();
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 4000);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

  async showUpsell(show) {
    
    this.upsellElement = this.querySelector('.cart-drawer--recommendations--container');
    
    if(show) {
      const res = await fetch('/?section_id=header');
      const section = await res.text();
      const header = document.createElement('div');
      header.innerHTML = section;
    
      const updatedRecommendations = header.querySelector('.cart-drawer--recommendations--products');
      const currentRecommendations = document.querySelector('.cart-drawer--recommendations--products');
        
      if (currentRecommendations && updatedRecommendations) {
        currentRecommendations.innerHTML = updatedRecommendations.innerHTML;
      }
      setTimeout(() => {
        this.upsellElement.classList.add('active');
      }, "500");
    } else {
      this.upsellElement.classList.remove('active');
    }
  }

  addUpsellToCart(event, addToCartButton) {
    event.preventDefault();
    addToCartButton.setAttribute('disabled', 'disabled');
  
    const variantId = addToCartButton.dataset.variantId;
  
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        this.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: 1
            }
          })
        );
        this._updateCart();
      } else {
        response.json().then((content) => {
          let errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'free-gift__form-error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 5000);
        });
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer._initEventListeners();
  }
});